import React, { useEffect, useState } from "react";
import Input from "componentsTemplate/Input/Input";
import ButtonPrimary from "componentsTemplate/Button/ButtonPrimary";
import NcLink from "componentsTemplate/NcLink/NcLink";
import Heading2 from "componentsTemplate/Heading/Heading2";
import LayoutOthers from "pages/layouts/LayoutOthers";
import Select from "componentsTemplate/Select/Select";

import useAuth from "hooks/useAuth";
import { useForm, Controller } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup"; // Import this package for TypeScript support
import { showToastError, showToastSuccess } from "utils/toasts";

// Icons
import { AiOutlineEyeInvisible, AiOutlineEye } from "react-icons/ai";
import { Checkbox } from "@mui/material";
import { useNavigate } from "react-router-dom";
import CountrySelect from "components/forms/inputs/SelectCountry";
import InputMasked from "componentsTemplate/Input/InputMasked";
import axios from "axios";
import { Interest, InterestResponse, index } from "services/InterestService";
import { getGroupCities } from "services/GroupCityService";
import { toast } from "react-toastify";


interface RegistrationFormValues {
  name: string;
  last_name: string;
  display_name: string;
  document: string;
  document_type_id: number;
  birth_date: string;
  email: string;
  phone: string;
  password: string;
  passwordConfirmation: string;
  linkedin: string | undefined;
  accept_terms: boolean;
  was_invited: boolean | undefined;
  instagram: string | undefined;
  facebook: string | undefined;
  x: string | undefined;
  youtube: string | undefined;
  tiktok: string | undefined;
  group_city_id: number | undefined;

  address: string;
  number: number;
  complement: string | undefined;
  district: string;
  state: string;
  city: string;
  postal_code: string | undefined;

  companyName: string | undefined;
  activity: string | undefined;
  website: string | undefined;
  position: string | undefined;

  name_inviter: string | undefined;

  interests: any;
  // interests: {
  //   [key: string]: boolean;
  // };
}

interface CountryType {
  code: string;
  label: string;
  phone: string;
  suggested?: boolean;
}

const validationSchema = yup.object().shape({
  name: yup.string().required("O nome é obrigatório"),
  last_name: yup.string().required("O sobrenome é obrigatório"),
  display_name: yup.string().required("O nome de uso é obrigatório"),
  document: yup.string().required("O documento é obrigatório"),
  document_type_id: yup.number().required("O tipo de documento é obrigatório"),
  birth_date: yup.string().required("A data de nascimento é obrigatória"),
  email: yup
    .string()
    .required("O e-mail é obrigatório")
    .email("Digite um e-mail válido"),
  phone: yup.string().required("O número de WhatsApp é obrigatório"),
  password: yup.string().required("A senha é obrigatória"),
  passwordConfirmation: yup
    .string()
    .required("A confirmação de senha é obrigatória"),
  linkedin: yup.string(),
  instagram: yup.string(),
  facebook: yup.string(),
  x: yup.string(),
  youtube: yup.string(),
  tiktok: yup.string(),
  group_city_id: yup.number(),

  address: yup.string().required("O endereço é obrigatório"),
  number: yup.number().required("O numero é obrigatório"),
  complement: yup.string(),
  district: yup.string().required("O bairro é obrigatório"),
  state: yup.string().required("O estado é obrigatório"),
  city: yup.string().required("A cidade é obrigatória"),
  postal_code: yup.string(),

  companyName: yup.string(),
  activity: yup.string(),
  website: yup.string(),
  position: yup.string(),

  // interestes é obrigatorio
  interests: yup.array().min(1, "Selecione pelo menos um interesse"),

  was_invited: yup.boolean(),
  // name_inviter: yup.string().test('conditional-validation', 'Informe o nome de quem te convidou', function(value) {
  //   const isRadarMember = this.parent.was_invited; // Obtenha o valor de radarMember
  //   if (!isRadarMember) {
  //     return !!value; // O campo é obrigatório se radarMember for falso
  //   }
  //   return true; // Sem validação se radarMember for verdadeiro
  // }),
  name_inviter: yup.string(),
  accept_terms: yup
    .boolean()
    .oneOf([true], "Você deve aceitar os termos")
    .required("Você deve aceitar os termos"),
});

const PageRegistration = () => {
  const navigate = useNavigate();
  const { register } = useAuth();
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [interestsData, setInterestsData] = useState<any>(null);

  const [interests, setInterests] = useState<string[]>([]);
  const [groupCities, setGroupCities] = useState<any>([]);

  const fetchGroupCities = async () => {
    try {
      const data = await getGroupCities();
      setGroupCities(data);
    } catch (error) {
      toast.error("Erro ao carregar as cidades");
    }
  };

  const handleInterestChange = (interestId: string) => {

    let newInterests = [];

    if (interests.includes(interestId)) {
      newInterests = interests.filter((id) => id !== interestId);
    } else {
      newInterests = [...interests, interestId];
    }

    setInterests(newInterests);
    setValue("interests", newInterests);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await index();
        setInterestsData(data);
      } catch (error) {
        // Lidar com erros, se necessário
      }
    };

    fetchData();
    fetchGroupCities();
  }, []);

  const { handleSubmit, control, formState, watch, setValue } =
    useForm<RegistrationFormValues>({
      resolver: yupResolver(validationSchema),
      defaultValues: {
        document_type_id: 1, // Define o valor inicial como 1 (CPF)
        was_invited: false,
      },
    });

  const { errors } = formState;

  const documentsType = [
    { id: 1, name: "CPF", mask: "999.999.999-99" },
    { id: 2, name: "CNPJ", mask: "99.999.999/9999-99" },
    { id: 3, name: 'Outro'}
  ];

  // Função para determinar a máscara com base no tipo de documento
  const getMask = (documentType: number) => {
    const document = documentsType.find((item) => item.id == documentType);
    return document?.mask ?? "";
  };

  // Máscara dinâmica para telefone com base no país selecionado
  const getPhoneMaskByCountry = () => {
    if (selectedCountry?.code === "BR") {
      return "+55 (99) 99999-9999";
    }
    const code = selectedCountry?.phone || "";
    const remaining = Math.max(1, 15 - code.length);
    const localMask = "9".repeat(remaining);
    return `+${code}${localMask ? ' ' + localMask : ''}`;
  };

  const onSubmit = async (data: RegistrationFormValues) => {
    setLoading(true);
    
    let dataForm = {
      name: data.name,
      last_name: data.last_name,
      display_name: data.display_name,
      email: data.email,
      document: data.document,
      document_type_id: data.document_type_id,
      birth_date: data.birth_date,
      phone: data.phone,
      password: data.password,
      passwordConfirmation: data.passwordConfirmation,
      linkedin: data.linkedin,
      accept_terms: data.accept_terms,
      was_invited: data.was_invited,
      instagram: data.instagram,
      facebook: data.facebook,
      x: data.x,
      youtube: data.youtube,
      tiktok: data.tiktok,
      group_city_id: data.group_city_id,

      address: data.address,
      number: data.number,
      complement: data.complement,
      district: data.district,
      country: selectedCountry?.label ?? "Brasil",
      state: data.state,
      city: data.city,
      postal_code: data.postal_code,

      name_inviter: data.name_inviter,

      interests: interests,

      companyName: data.companyName,
      activity: data.activity,
      website: data.website,
      position: data.position,
    };

    const normalizedPhone = (data.phone || "").replace(/[^\d+]/g, "");
    dataForm.phone = normalizedPhone;

    try {
      await register(dataForm);
  
      navigate("/login");
      showToastSuccess("Cadastro realizado com sucesso! Efetue o login para prosseguir.");

    } catch (error: any) {
      console.log("Erro no cadastro", error);
      setLoading(false);
  
      

      if (error.response) {
        // Caso seja um erro de validação do Laravel
        if (error.response.data?.errors) {
          const firstErrorKey = Object.keys(error.response.data.errors)[0]; // Pega a primeira chave
          const firstErrorMessage = error.response.data.errors[firstErrorKey][0]; // Pega a primeira mensagem
          showToastError(firstErrorMessage);
        } else if (error.response.data?.message) {
          // Caso seja uma mensagem genérica da API
          showToastError(error.response.data.message);
        } else {
          // Outros erros conhecidos
          showToastError("Erro inesperado no cadastro. Tente novamente mais tarde.");
        }
      } else {
        // Caso seja um erro de conexão ou desconhecido
        showToastError("Erro de conexão. Verifique sua internet e tente novamente.");
      }
    }
  };
  

  const [selectedCountry, setSelectedCountry]: any =
    useState<CountryType | null>(null);
  const documentType = watch("document_type_id");
  const was_invited = watch("was_invited");

  const handleCountryChange = (newValue: CountryType | null) => {
    setSelectedCountry(newValue);

    // Controle do doc e da mascara do doc
    if (newValue?.code != "BR") {
      setValue("document", "");
      setValue("document_type_id", 3);
      setValue("phone", "");
    } else {
      setValue("document_type_id", 1);
      setValue("phone", "");
    }
  };

  const verificarEstado = (e: any, field: any) => {
    if (selectedCountry.code == "BR") {
      if (e.target.value.length > 2) {
        showToastError("Os estados brasileiros contém apenas 2 caracteres.");
        return;
      } else {
        field.onChange(e.target.value);
      }
    } else {
      field.onChange(e.target.value);
    }
  };

  const getAddressFromCep = async (cep: string) => {
    try {
      const response = await axios.get(`https://viacep.com.br/ws/${cep}/json/`);
      const addressData = response.data;

      if (!addressData.erro) {
        // Preencha os campos do endereço com os dados recebidos
        setValue("address", addressData.logradouro || "");
        setValue("complement", addressData.complemento || "");
        setValue("district", addressData.bairro || "");
        setValue("city", addressData.localidade || "");
        setValue("state", addressData.uf || "");
      } else {
        // Se a API ViaCep retornar erro, exiba um Toast
        showToastError(
          "Não foi possível encontrar o endereço com o CEP fornecido."
        );
      }
    } catch (error) {
      console.error("Erro ao obter endereço do CEP", error);
      showToastError("Ocorreu um erro ao buscar o endereço.");
    }
  };

  // Função chamada quando o CEP é alterado
  const handleCepChange = (cep: string) => {
    // Remova caracteres não numéricos do CEP
    const cleanCep = cep.replace(/\D/g, "");

    // Verifique se o CEP tem o comprimento correto
    if (cleanCep.length === 8) {
      // Faça a chamada à API ViaCep
      setValue("postal_code", cep);
      getAddressFromCep(cleanCep);
    }
  };

  useEffect(() => {
    if (selectedCountry?.code != "BR") {

    } else {

    }

  }, [selectedCountry]);

  return (
    <LayoutOthers>
      <header className="text-center max-w-2xl mx-auto mb-14 sm:mb-16 lg:mb-20">
        <Heading2>Cadastro de Membro</Heading2>
        <span className="block text-sm mt-2 text-primary-700 sm:text-base dark:text-primary-200">
          Venha ser uma Radar, e faça parte da nossa comunidade!
        </span>
      </header>

      <form className="" onSubmit={handleSubmit(onSubmit)}>
        <div className="h-20 px-8 mb-10">
          {/* <span className="text-neutral-800 dark:text-neutral-200">País onde Reside</span> */}
          {/* <Controller
            name="country"
            control={control}
            render={({ field }) => (
              <> */}
          <CountrySelect onCountryChange={handleCountryChange} />
          {/* {errors.website && <small className="text-red-500">{errors.website.message}</small>} */}
          {/* </>
            )}
          /> */}
        </div>

        {selectedCountry && (
          <>
            <div className="grid grid-cols-1 md:grid-cols-2 divide-x-2">
              <div className="grid gap-6 px-8">
                {/* <div className="grid gap-2 grid-cols-1  md:grid-cols-2"> */}
                <div className="h-20">
                  <span className="text-neutral-800 dark:text-neutral-200">
                    Nome *
                  </span>
                  <Controller
                    name="name"
                    control={control}
                    render={({ field }) => (
                      <>
                        <Input
                          {...field}
                          type="text"
                          autoComplete="name"
                          value={field.value || ""}
                        />
                        {errors.name && (
                          <small className="text-red-500">
                            {errors.name.message}
                          </small>
                        )}
                      </>
                    )}
                  />
                </div>
                {/* </div> */}

                <div className="h-20">
                  <span className="text-neutral-800 dark:text-neutral-200">
                    Sobrenome *
                  </span>
                  <Controller
                    name="last_name"
                    control={control}
                    render={({ field }) => (
                      <>
                        <Input
                          {...field}
                          type="text"
                          autoComplete="last_name"
                          value={field.value || ""}
                        />
                        {errors.last_name && (
                          <small className="text-red-500">
                            {errors.last_name.message}
                          </small>
                        )}
                      </>
                    )}
                  />
                </div>

                <div className="h-20">
                  <span className="text-neutral-800 dark:text-neutral-200">
                    Como deseja ser chamado ? *
                  </span>
                  <Controller
                    name="display_name"
                    control={control}
                    render={({ field }) => (
                      <>
                        <Input
                          {...field}
                          type="text"
                          autoComplete="display_name"
                          value={field.value || ""}
                        />
                        {errors.display_name && (
                          <small className="text-red-500">
                            {errors.display_name.message}
                          </small>
                        )}
                      </>
                    )}
                  />
                </div>

                <div className="h-20">
                  <span className="text-neutral-800 dark:text-neutral-200">
                    Endereço de Email *
                  </span>
                  <Controller
                    name="email"
                    control={control}
                    render={({ field }) => (
                      <>
                        <Input
                          {...field}
                          type="email"
                          autoComplete="username"
                          value={field.value || ""}
                        />
                        {errors.email && (
                          <small className="text-red-500">
                            {errors.email.message}
                          </small>
                        )}
                      </>
                    )}
                  />
                </div>

                <div className="h-20">
                  <span className="flex justify-between items-center text-neutral-800 dark:text-neutral-200">
                    Senha *
                  </span>
                  <div className="relative">
                    <Controller
                      name="password"
                      control={control}
                      render={({ field }) => (
                        <>
                          <Input
                            {...field}
                            type={showPassword ? "text" : "password"}
                            autoComplete="current-password"
                            value={field.value || ""}
                          />
                          {errors.password && (
                            <small className="text-red-500">
                              {errors.password.message}
                            </small>
                          )}
                        </>
                      )}
                    />
                    <button
                      type="button"
                      onClick={() => setShowPassword(!showPassword)}
                      className="absolute inset-y-0 right-0 flex mt-3 pr-3 focus:outline-none"
                    >
                      {showPassword ? (
                        <AiOutlineEyeInvisible color="gray" size={22} />
                      ) : (
                        <AiOutlineEye color="gray" size={22} />
                      )}
                    </button>
                  </div>
                </div>

                <div className="h-20">
                  <span className="flex justify-between text-neutral-800 dark:text-neutral-200">
                    Repetir Senha *
                  </span>
                  <div className="relative">
                    <Controller
                      name="passwordConfirmation"
                      control={control}
                      render={({ field }) => (
                        <>
                          <Input
                            {...field}
                            type={showPassword ? "text" : "password"}
                            autoComplete="confirmation-password"
                            value={field.value || ""}
                          />
                          {errors.passwordConfirmation && (
                            <small className="text-red-500">
                              {errors.passwordConfirmation.message}
                            </small>
                          )}
                        </>
                      )}
                    />
                    <button
                      type="button"
                      onClick={() => setShowPassword(!showPassword)}
                      className="absolute inset-y-0 right-0 flex mt-3 pr-3 focus:outline-none"
                    >
                      {showPassword ? (
                        <AiOutlineEyeInvisible color="gray" size={22} />
                      ) : (
                        <AiOutlineEye color="gray" size={22} />
                      )}
                    </button>
                  </div>
                </div>

                <div className="h-20 grid grid-cols-7">
                  <div className="col-span-5">
                    <span className="text-neutral-800 dark:text-neutral-200">
                      Registro *
                    </span>
                    <Controller
                      name="document"
                      control={control}
                      render={({ field }) => (
                        <>
                          {/* <Input {...field} className="rounded-r-lg" type="text" autoComplete="document" value={field.value || ''}/> */}

                          <InputMasked
                            {...field}
                            type="text"
                            className="rounded-r-lg"
                            autoComplete="cep"
                            mask={getMask(documentType)}
                          />

                          {errors.document && (
                            <small className="text-red-500">
                              {errors.document.message}
                            </small>
                          )}
                        </>
                      )}
                    />
                  </div>
                  <div className="col-span-2">
                    <span className="text-neutral-800 dark:text-neutral-200">
                      Doc.
                    </span>
                    
                    <Controller
                      name="document_type_id"
                      control={control}
                      render={({ field }) => (
                        <>
                          {/* <Input {...field} className="rounded-l-lg" type="text" autoComplete="document" value={field.value || ''}/> */}

                          <Select className="rounded-r-full" {...field}>

                            {selectedCountry?.code == "BR" ? (
                              <>
                                <option value="1">CPF</option>
                                <option value="2">CNPJ</option>
                              </>
                            ) : (
                              <option value="3">Outro</option>
                            )}

                            {/* {documentsType.map((item) => (
                              <option selected={item.id == 1} value={item.id}>
                                {item.name}
                              </option>
                            ))} */}
                          </Select>
                          {errors.document_type_id && (
                            <small className="text-red-500">
                              {errors.document_type_id.message}
                            </small>
                          )}
                        </>
                      )}
                    />
                  </div>
                </div>

                <div className="h-20">
                  <span className="text-neutral-800 dark:text-neutral-200">
                    Data de Nascimento *
                  </span>
                  <Controller
                    name="birth_date"
                    control={control}
                    render={({ field }) => (
                      <>
                        <Input
                          {...field}
                          type="date"
                          autoComplete="birth_date"
                          value={field.value || ""}
                        />
                        {errors.birth_date && (
                          <small className="text-red-500">
                            {errors.birth_date.message}
                          </small>
                        )}
                      </>
                    )}
                  />
                </div>

                <div className="h-20">
                  <span className="text-neutral-800 dark:text-neutral-200">
                    Numero (WhatsApp) *
                  </span>
                  <Controller
                    name="phone"
                    control={control}
                    render={({ field }) => (
                      <>
                        <InputMasked
                          {...field}
                          type="text"
                          className=""
                          autoComplete="phone"
                          mask={getPhoneMaskByCountry()}
                          maskChar={selectedCountry?.code === 'BR' ? '_' : ''}
                          value={field.value || ""}
                        />
                        {/* <Input {...field} type="text" autoComplete="phone" value={field.value || ''}/> */}
                        {errors.phone && (
                          <small className="text-red-500">
                            {errors.phone.message}
                          </small>
                        )}
                      </>
                    )}
                  />
                </div>

                <div className="h-20">
                  <span className="text-neutral-800 dark:text-neutral-200">
                    Linkedin
                  </span>
                  <Controller
                    name="linkedin"
                    control={control}
                    render={({ field }) => (
                      <>
                        <Input
                          {...field}
                          type="text"
                          autoComplete="linkedin"
                          value={field.value || ""}
                        />
                        {errors.linkedin && (
                          <small className="text-red-500">
                            {errors.linkedin.message}
                          </small>
                        )}
                      </>
                    )}
                  />
                </div>

                <div className="h-20">
                  <span className="text-neutral-800 dark:text-neutral-200">
                      Instagram
                  </span>
                  <Controller
                    name="instagram"
                    control={control}
                    render={({ field }) => (
                      <>
                        <Input
                          {...field}
                          type="text"
                          autoComplete="instagram"
                          value={field.value || ""}
                        />
                        {errors.instagram && (
                          <small className="text-red-500">
                            {errors.instagram.message}
                          </small>
                        )}
                      </>
                    )}
                  />
                </div>

                <div className="h-20">
                  <span className="text-neutral-800 dark:text-neutral-200">
                    X (Twitter)
                  </span>
                  <Controller
                    name="x"
                    control={control}
                    render={({ field }) => (
                      <>
                        <Input
                          {...field}
                          type="text"
                          autoComplete="x"
                          value={field.value || ""}
                        />
                        {errors.x && (
                          <small className="text-red-500">
                            {errors.x.message}
                          </small>
                        )}
                      </>
                    )}
                  />
                </div>

                <div className="h-20">
                  <span className="text-neutral-800 dark:text-neutral-200">
                      Facebook
                  </span>
                  <Controller
                    name="facebook"
                    control={control}
                    render={({ field }) => (
                      <>
                        <Input
                          {...field}
                          type="text"
                          autoComplete="facebook"
                          value={field.value || ""}
                        />
                        {errors.facebook && (
                          <small className="text-red-500">
                            {errors.facebook.message}
                          </small>
                        )}
                      </>
                    )}
                  />
                </div>
              </div>

              <div className="grid gap-6 px-8">
                {selectedCountry?.code == "BR" && (
                  <div className="h-20">
                    <span className="text-neutral-800 dark:text-neutral-200">
                      CEP *
                    </span>
                    <Controller
                      name="postal_code"
                      control={control}
                      render={({ field }) => (
                        <>
                          {/* <Input {...field} type="text" autoComplete="postal_code" value={field.value || ''}/> */}
                          <InputMasked
                            {...field}
                            type="text"
                            autoComplete="postal_code"
                            mask="99999-999"
                            onChange={(e) => handleCepChange(e.target.value)}
                            // onBlur={(e) => handleCepChange(e.target.value)}
                          />
                          {errors.postal_code && (
                            <small className="text-red-500">
                              {errors.postal_code.message}
                            </small>
                          )}
                        </>
                      )}
                    />
                  </div>
                )}

                <div className="h-20">
                  <span className="text-neutral-800 dark:text-neutral-200">
                    Estado *
                  </span>
                  <Controller
                    name="state"
                    control={control}
                    render={({ field }) => (
                      <>
                        <Input
                          {...field}
                          type="text"
                          autoComplete="state"
                          onChange={(e) => verificarEstado(e, field)}
                          value={field.value || ""}
                        />
                        {errors.state && (
                          <small className="text-red-500">
                            {errors.state.message}
                          </small>
                        )}
                      </>
                    )}
                  />
                </div>

                <div className="h-20">
                  <span className="text-neutral-800 dark:text-neutral-200">
                    Cidade *
                  </span>
                  <Controller
                    name="city"
                    control={control}
                    render={({ field }) => (
                      <>
                        <Input
                          {...field}
                          type="text"
                          autoComplete="city"
                          value={field.value || ""}
                        />
                        {errors.city && (
                          <small className="text-red-500">
                            {errors.city.message}
                          </small>
                        )}
                      </>
                    )}
                  />
                </div>

                <div className="h-20">
                  <span className="text-neutral-800 dark:text-neutral-200">
                    Bairro *
                  </span>
                  <Controller
                    name="district"
                    control={control}
                    render={({ field }) => (
                      <>
                        <Input
                          {...field}
                          type="text"
                          autoComplete="district"
                          value={field.value || ""}
                        />
                        {errors.district && (
                          <small className="text-red-500">
                            {errors.district.message ?? " "}
                          </small>
                        )}
                      </>
                    )}
                  />
                </div>

                <div className="h-20">
                  <span className="text-neutral-800 dark:text-neutral-200">
                    Endereço *
                  </span>
                  <Controller
                    name="address"
                    control={control}
                    render={({ field }) => (
                      <>
                        <Input
                          {...field}
                          type="text"
                          autoComplete="address"
                          value={field.value || ""}
                        />
                        {errors.address && (
                          <small className="text-red-500">
                            {errors.address.message ?? " "}
                          </small>
                        )}
                      </>
                    )}
                  />
                </div>

                <div className="grid gap-2 grid-cols-1  md:grid-cols-2">
                  <div className="h-20">
                    <span className="text-neutral-800 dark:text-neutral-200">
                      Numero *
                    </span>
                    <Controller
                      name="number"
                      control={control}
                      render={({ field }) => (
                        <>
                          <Input
                            {...field}
                            type="number"
                            autoComplete="number"
                            value={field.value || ""}
                          />
                          {errors.number && (
                            <small className="text-red-500">
                              {errors.number.message ?? " "}
                            </small>
                          )}
                        </>
                      )}
                    />
                  </div>

                  <div className="h-20">
                    <span className="text-neutral-800 dark:text-neutral-200">
                      Complemento
                    </span>
                    <Controller
                      name="complement"
                      control={control}
                      render={({ field }) => (
                        <>
                          <Input
                            {...field}
                            type="text"
                            autoComplete="complement"
                            value={field.value || ""}
                          />
                          {errors.complement && (
                            <small className="text-red-500">
                              {errors.complement.message ?? " "}
                            </small>
                          )}
                        </>
                      )}
                    />
                  </div>
                </div>

                <div className="h-20">
                  <span className="text-neutral-800 dark:text-neutral-200">
                    Nome da Empresa
                  </span>
                  <Controller
                    name="companyName"
                    control={control}
                    render={({ field }) => (
                      <>
                        <Input
                          placeholder="Opcional..."
                          {...field}
                          type="text"
                          autoComplete="companyName"
                          value={field.value || ""}
                        />
                        {errors.companyName && (
                          <small className="text-red-500">
                            {errors.companyName.message}
                          </small>
                        )}
                      </>
                    )}
                  />
                </div>

                <div className="h-20">
                  <span className="text-neutral-800 dark:text-neutral-200">
                    Atividade
                  </span>
                  <Controller
                    name="activity"
                    control={control}
                    render={({ field }) => (
                      <>
                        <Input
                          placeholder="Opcional..."
                          {...field}
                          type="text"
                          autoComplete="activity"
                          value={field.value || ""}
                        />
                        {errors.activity && (
                          <small className="text-red-500">
                            {errors.activity.message}
                          </small>
                        )}
                      </>
                    )}
                  />
                </div>

                <div className="h-20">
                  <span className="text-neutral-800 dark:text-neutral-200">
                    Cargo
                  </span>
                  <Controller
                    name="position"
                    control={control}
                    render={({ field }) => (
                      <>
                        <Input
                          placeholder="Opcional..."
                          {...field}
                          type="text"
                          autoComplete="position"
                          value={field.value || ""}
                        />
                        {errors.position && (
                          <small className="text-red-500">
                            {errors.position.message}
                          </small>
                        )}
                      </>
                    )}
                  />
                </div>

                <div className="h-20">
                  <span className="text-neutral-800 dark:text-neutral-200">
                    Site da Empresa
                  </span>
                  <Controller
                    name="website"
                    control={control}
                    render={({ field }) => (
                      <>
                        <Input
                          placeholder="Opcional..."
                          {...field}
                          type="text"
                          autoComplete="website"
                          value={field.value || ""}
                        />
                        {errors.website && (
                          <small className="text-red-500">
                            {errors.website.message}
                          </small>
                        )}
                      </>
                    )}
                  />
                </div>

                <div className="h-20">
                  <span className="text-neutral-800 dark:text-neutral-200">
                      Youtube
                  </span>
                  <Controller
                    name="youtube"
                    control={control}
                    render={({ field }) => (
                      <>
                        <Input
                          {...field}
                          type="text"
                          autoComplete="youtube"
                          value={field.value || ""}
                        />
                        {errors.youtube && (
                          <small className="text-red-500">
                            {errors.youtube.message}
                          </small>
                        )}
                      </>
                    )}
                  />
                </div>

                <div className="h-20">
                  <span className="text-neutral-800 dark:text-neutral-200">
                      Tiktok
                  </span>
                  <Controller
                    name="tiktok"
                    control={control}
                    render={({ field }) => (
                      <>
                        <Input
                          {...field}
                          type="text"
                          autoComplete="tiktok"
                          value={field.value || ""}
                        />
                        {errors.tiktok && (
                          <small className="text-red-500">
                            {errors.tiktok.message}
                          </small>
                        )}
                      </>
                    )}
                  />
                </div>

                <div className="h-20">
                  <span className="text-neutral-800 dark:text-neutral-200">
                    Qual Grupo de Cidade Radar você pertence?
                  </span>
                  <Controller
                    name="group_city_id"
                    control={control}
                    render={({ field }) => (
                      <>
                        <Select
                          {...field}
                          className="rounded-r-full rounded-l-full"
                        >
                          <option value="">Selecione...</option>
                          {
                            groupCities?.map((city: any) => (
                              <option key={city.id} value={city.id}>
                                {city.name}
                              </option>
                            ))
                          }
                        </Select>
                        {errors.group_city_id && (
                          <small className="text-red-500">
                            {errors.group_city_id.message}
                          </small>
                        )}
                      </>
                    )}
                  />
                </div>

                {/* <span className="text-neutral-800 dark:text-neutral-200">País *</span>
                    <Controller
                      name="country"
                      control={control}
                      render={({ field }) => (
                        <>
                          <Input {...field} type="text" autoComplete="country" value={field.value || ''}/>
                          {errors.country && <small className="text-red-500">{errors.country.message}</small>}
                        </>
                      )}
                    /> */}
                {/* </div> */}

                {selectedCountry?.code != "BR" && <div className="h-20"></div>}
              </div>
            </div>

            {interestsData && (
              <div className="mt-8">
                <span className="text-neutral-800 dark:text-neutral-200">
                  Selecione seus interesses *
                </span>
                <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-1 mt-5">
                  {interestsData?.map((interest: any) => (
                    <div key={interest.id} className="mr-4">
                      <div className="flex">
                        <Checkbox
                          id={`interesse_${interest.id}`}
                          checked={interests.includes(interest.id)}
                          inputProps={{ "aria-label": "controlled" }}
                          onChange={() => handleInterestChange(interest.id)}
                        />
                        <label
                          htmlFor={`interesse_${interest.id}`}
                          className="block mt-2 cursor-pointer"
                        >
                          {interest.name}
                        </label>
                      </div>
                    </div>
                  ))}
                </div>

                {errors.interests && (
                  <small className="text-red-500">
                    {errors.interests.message}
                  </small>
                )}

              </div>
            )}

            <hr className="mt-8" />

            <div className="mt-14">
              <Controller
                name="accept_terms"
                control={control}
                render={({ field }) => (
                  <>
                    <div className="flex">
                      <Checkbox
                        id="accept_terms"
                        {...field}
                        inputProps={{ "aria-label": "controlled" }}
                      />
                      <label
                        htmlFor="accept_terms"
                        className="block mt-2 cursor-pointer"
                      >
                        Eu concordo e aceito integralmente com os <a target="blank" href="/termos-de-uso"><b>termos de uso</b></a>
                        *
                      </label>
                    </div>
                    <div className="pl-8 ">
                      {errors.accept_terms && (
                        <small className="text-red-500">
                          {errors.accept_terms.message}
                        </small>
                      )}
                    </div>
                  </>
                )}
              />
            </div>

            <div>
              <Controller
                name="was_invited"
                control={control}
                render={({ field }) => (
                  <>
                    <div className="flex">
                      <Checkbox
                        id="was_invited"
                        {...field}
                        inputProps={{ "aria-label": "controlled" }}
                      />
                      <label
                        htmlFor="was_invited"
                        className="block mt-2 cursor-pointer"
                      >
                        Fui convidado por uma radar{" "}
                      </label>
                    </div>
                    <div className="pl-8 ">
                      {errors.was_invited && (
                        <small className="text-red-500">
                          {errors.was_invited.message}
                        </small>
                      )}
                    </div>
                  </>
                )}
              />
            </div>

            <div
              className={`transition-all overflow-hidden duration-300 ${
                was_invited ? "h-auto mt-3 px-2" : "h-0 mt-0 px-0"
              }`}
            >
              {/* <span className="text-neutral-800 dark:text-neutral-200">Nome da radar *</span> */}
              <Controller
                name="name_inviter"
                control={control}
                render={({ field }) => (
                  <>
                    <Input
                      placeholder="Nos informe o nome da Radar..."
                      {...field}
                      type="text"
                      autoComplete="name_inviter"
                      value={field.value || ""}
                    />
                    {errors.name_inviter && (
                      <small className="text-red-500">
                        {errors.name_inviter.message}
                      </small>
                    )}
                  </>
                )}
              />
            </div>
          </>
        )}

        <div className="flex justify-center mt-14">
          <ButtonPrimary
            disabled={!selectedCountry || loading}
            sizeClass="py-3 px-4 sm:py-3.5 sm:px-20"
            type="submit"
          >
            Prosseguir Cadastro
            {
              loading && (
                <div role="status" className="ml-3">
                    <svg aria-hidden="true" className="inline w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-gray-600 dark:fill-gray-300" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/>
                        <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/>
                    </svg>
                </div>
              )
            }
          </ButtonPrimary>
        </div>
      </form>

      <div className="mx-auto space-y-6 mt-8">
        {/* OR */}
        <div className="relative text-center">
          <span className="relative z-10 inline-block px-4 font-medium text-sm bg-white dark:text-neutral-400 dark:bg-neutral-900">
            {/* OR */}
          </span>
          <div className="absolute left-0 w-full top-1/2 transform -translate-y-1/2 border border-neutral-100 dark:border-neutral-800"></div>
        </div>

        {/* ==== */}
        <span className="block text-center text-neutral-700 dark:text-neutral-300">
          Já possuí conta? {` `}
          <NcLink href="/login">Ir para login</NcLink>
        </span>
      </div>
    </LayoutOthers>
  );
};

export default PageRegistration;
